import styled from "styled-components";

export const Container = styled.header`
  display: flex;
  align-items: center;
  padding: 1rem;
  background: linear-gradient(135deg, #5882f2 0%, #61e0af 100%);
  border-bottom: 1px solid #e0e0e0;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    padding: 0.8rem;
    justify-content: center;
  }
`;

export const Row = styled.div`
  display: flex;
  flex: 1;

  img {
    height: 32px;
    display: flex;
    object-fit: contain;

    @media (max-width: 768px) {
      height: 28px;
    }
  }

  p {
    display: flex;
    flex: 1;
    text-align: center;
    align-self: center;
    margin-left: -80px;
    font-family: "Roboto", sans-serif;
    font-size: 22px;
    font-weight: 500;
    color: #fff;

    @media (max-width: 768px) {
      margin-left: 0;
      justify-content: center;
      font-size: 18px;
    }
  }

  @media (max-width: 768px) {
    flex: none;
    width: 100%;
    justify-content: center;
    margin: 0.4rem 0;
  }
`;
